import { compose } from 'redux';
import { connect } from 'react-redux';
import informationModule from 'app/store/information';
import eventsModule from 'app/store/events';
import Landing from './Landing.component';

const { landingInfoRequest, requestMainUrl } = informationModule.actions;
const { resetAllEvents } = eventsModule.actions;

const mapStateToProps = ({ information }) => (
  {
    content: information.landing,
    mainUrl: information?.mainUrl,
  });

const mapDispatchToProps = {
  fetchContentLanding: landingInfoRequest,
  resetState: resetAllEvents,
  fetchMainUrl: requestMainUrl,
};

export default compose(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )
)(Landing);
